const projects = [
  {
    name: "Trippin",
    description:
      "A day-trip planning app where users may search for nearby attractions, restaurants, museums, etc. and build out a schedule with their chosen destinations.",
    image: null,
    frontend: "http://github.com/MACorman/trippy_frontend",
    backend: "http://github.com/MACorman/trippy_backend",
    url: null,
    demo: "sFWCz6InhrQ",
  },
  {
    name: "NutriPal",
    description:
      "A nutrition and weight tracking app where users may build out a daily food diary with their chosen foods, view the associated nutritional breakdown, and track their body weight.",
    image: "nutripal",
    frontend: "https://github.com/MACorman/mfp_frontend",
    backend: "https://github.com/MACorman/mfp_clone_backend",
    url: null,
    demo: null,
  },
  {
    name: "Forbes Mobile App Clone",
    description:
      "A clone of the Forbes mobile app featuring the latest news stories and videos from Forbes, as well as the ability to purchase issues of the magazine.",
    image: "forbes",
    frontend: "https://github.com/MACorman/forbes_clone_frontend",
    backend: "https://github.com/MACorman/forbes_backend",
    url: null,
    demo: "jzqT3gA2z1Y",
  },
  // {
  //   name: `Bill and Ted's Excellent SuperStore`,
  //   description:
  //     "An e-commerce app where users may buy and sell products as well as manage their inventory. ",
  //   image: null,
  //   frontend: "https://github.com/MACorman/mod-4-proj-frontend",
  //   backend: "https://github.com/MACorman/mod-4-proj-backend",
  //   url: null,
  //   demo: "l11FhE6I58I",
  // },
  // {
  //   name: "CodeHub",
  //   description:
  //     "A central hub of coding tutorial videos, organized by language, to simplify learning to code.",
  //   image: null,
  //   frontend: "https://github.com/MACorman/codehub-frontend",
  //   backend: "https://github.com/shakilabdin/codehub-backend",
  //   url: "https://macorman.github.io/codehub-frontend/",
  //   demo: "3uWKtRK8OX8",
  // },
];

export default projects;
